import axios from 'axios'
import { buildQuery } from '../exports/queryStringBuilder'


export default {
    //////checkoff actions
    async selectCheckoffOrders(checkoff_type_id) {
        return await axios.get(`order/bulk-checkoffs/?type=${checkoff_type_id}`)
    },

    async bulkCheckoffOrders(payload) {
        return await axios.post(`order/bulk-checkoffs`, payload)
    },

    //////////////////////////

    async myorders() {
        return await axios.get(`order/my_orders`)
    },

    async fetchPresigned(type, key) {
        const path = `presigned/${type}?key=${key || 0}`
        return await axios.get(path)
    },

    async create(model) {
        return await axios.post(`order`, model)
    },
    async fetchById(id) {
        return await axios.get(`order/${id}`)
    },
    async fetch(query, filters, page) {
        return await axios.get(
            `order?q=${query}&page=${page}&` + buildQuery(filters)
        )
    },
    async fetchDrivers() {
        return await axios.get(`user/all`)
    },
   

    async update(id, model) {
        console.log('api model', model)
        return await axios.put(`order/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`order/${id}`)
    },
    async markAsComplete(id,address) {
        return await axios.post(`order/${id}/complete`,address)
    },
    async markAsIncomplete(id) {
        return await axios.post(`order/${id}/incomplete`)
    },

    async updateTasks(orderId, tasks) {
        return await axios.post(`order/${orderId}/checklist`, {
            data: tasks,
        })
    },

    /* Order Items */
    async fetchOrderItems(orderId) {
        return await axios.get(`order/${orderId}/items`)
    },

    async updateOrderItems(orderId, { total, items }) {
        return await axios.post(`order/${orderId}/items`, { total, items })
    },

    async createOrderItem(orderId, item) {
        return await axios.post(`order/${orderId}/create_item`, item)
    },

    async updateOrderItem(orderId, id, item) {
        return await axios.put(`order/${orderId}/items/${id}`, item)
    },

    async deleteOrderItem(orderId, id) {
        return await axios.delete(`order/${orderId}/items/${id}`)
    },
    // creates a whole order from an order definition
    // this is used by the
    async uploadOrder(order) {
        return await axios.post(`order/order_upload`, order)
    },

    /* Checkoff */
    async createCheckoff(orderId, data) {
        return await axios.post(`order/${orderId}/checkoff`, data)
    },

    async updateCheckoff(orderId, checkoffId, data) {
        return await axios.put(`order/${orderId}/checkoff/${checkoffId}`, data)
    },

    async deleteCheckoff(orderId, checkoffId) {
        return await axios.delete(`order/${orderId}/checkoff/${checkoffId}`)
    },

    /* checkoff Attachment */
    async deleteCheckoffAttachment(orderId, checkoffId, attachmentId) {
        const path = `order/${orderId}/checkoff/${checkoffId}/attachment/${attachmentId}`
        return await axios.delete(path)
    },
    async addCheckoffAttachment(orderId, checkoffId, url) {
        const path = `order/${orderId}/checkoff/${checkoffId}/attachment`
        console.log('path', path)
        return await axios.post(path, { url })
    },

    /* Notes */
    async createNote(orderId, content) {
        return await axios.post(`order/${orderId}/note`, { content })
    },

    async deleteNote(orderId, noteId) {
        return await axios.delete(`order/${orderId}/note/${noteId}`)
    },

    /* Attachment */
    async deleteAttachment(orderId, attachmentId) {
        return await axios.delete(`order/${orderId}/attachment/${attachmentId}`)
    },
    async addAttachment(attachment) {
        const { order_id, long, lat, url } = attachment
        let path = `order/${order_id}/attachment`
        return await axios.post(path, { long, lat, url })
    },

    /* Bulk Actions */

    ///////////////////////////////
    async bulkSetDriver(orders, driverId) {
        return await axios.post(`order/bulk_set_driver`, {
            driverId: driverId,
            orders: orders.map(x => x.id),
        })
    },
    async bulkRelease(orders) {
        return await axios.post(`order/bulk_release`, {
            orders,
        })
    },
    async bulkSetWarehouse(orders, warehouseId) {
        return await axios.post(`order/bulk_set_warehouse`, {
            warehouseId: warehouseId,
            orders: orders.map(x => x.id),
        })
    },
    async bulkSetIncomplete(payload) {
        return await axios.post(`order/bulk_set_incomplete`, payload)
    },
    async bulkDelete(orders) {
        return await axios.post(`order/bulk_delete`, {
            orders: orders.map(x => x.id),
        })
    },

    ///template
    async createTemplate(orderId, template) {
        return await axios.post(`order/${orderId}/create_template`, template)
    },
}
